<template>
    <div>
        <v-progress-linear :indeterminate="true" v-if="loading2" />
        <v-data-table :headers="headers" :items="data2.contacts" v-if="!loading"></v-data-table>
    </div>
</template>

<script>
import ProductMixin from "@/mixins/Product";

export default {
    mixins: [ProductMixin],
    data: () => ({
        loading2: true,
        data2: {},
        headers: [
            { text: 'First name', value: 'firstName' },
            { text: 'Last name', value: 'lastName' },
            { text: 'Email', value: 'email' },
        ],
    }),
    mounted() {
        this.fetcho();
    },
    methods: {
        async fetcho() {
            this.loading2 = true;
            this.data2 = await this.action("list_contacts");
            this.loading2 = false;
        }
    }
}
</script>